<template>
  <div class="relative">
    <Button
      class="!hidden md:!flex"
      prefix_icon="ic-cart"
      :test-id="TEST_IDS.CART_BUTTON"
      :c_style="{ type: 'text', style: 'A' }"
      :label="$t('common.titles.cart')"
      :link="{ path }"
    />

    <IconButton
      class="md:hidden"
      name="ic-cart"
      :test-id="TEST_IDS.CART_BUTTON"
      :c_style="{ type: 'ghost' }"
      :link="{ path }"
    />

    <div
      class="absolute -top-[3px] start-4 grid h-4 w-4 place-items-center rounded-full bg-action text-xs font-medium text-action_text lg:start-5 lg:top-0"
      :test-id="TEST_IDS.CART_ITEM_COUNT"
    >
      <span class="h-fit w-fit font-secondary">
        {{ cartItemsNo }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Button from "~/components/common/Atom/Button.vue";
import IconButton from "~/components/common/Atom/IconButton.vue";
import TEST_IDS from "~~/tests/constants/ids";

defineProps<{
  cartItemsNo: number | string;
  path: string;
}>();
</script>
